import _ from 'underscore';

export default function SaveCreativeService(
  $http,
  $q,
  CreativeService,
  DataService,
  FlashService,
  MixpanelService,
  RenderService
) {
  const vm = this;

  vm.save = save;
  vm.saveGroup = saveGroup;

  function save(creative) {
    if (RenderService.site && RenderService.site.id) {
      creative.siteId = RenderService.site.id;
    }

    return DataService.save(creative).then(
      response => success(response),
      response => failure(response)
    );
  }

  function prepareAllCreatives(group) {
    let newGroup = JSON.parse(JSON.stringify(group));

    newGroup.creativePreviews.map(creative =>
      DataService.prepareCreative(creative)
    );

    return newGroup;
  }

  function createGroup(group) {
    MixpanelService.track('Created Creative Group', {
      creativeCount: group.creativePreviews.length,
      groupName: group.name
    });

    return $http
      .post('/creative_groups', {
        creativeGroup: prepareAllCreatives(group)
      })
      .then(response => success(response), response => failure(response));
  }

  function updateGroup(group) {
    MixpanelService.track('Updated Creative Group', {
      creativeCount: group.creativePreviews.length,
      groupId: group.id
    });

    return $http
      .patch(`/creative_groups/${group.id}`, {
        creativeGroup: prepareAllCreatives(group)
      })
      .then(response => success(response), response => failure(response));
  }

  function saveGroup(group) {
    group.name = group.name || 'New Creative Group';
    group.creativePreviews = _.map(group.creativePreviews, creative =>
      DataService.prepareCreative(creative)
    );

    if (group.id) {
      return updateGroup(group);
    }

    return createGroup(group);
  }

  function success(response) {
    let creative = response.data;

    DataService.updateUserCreatives();
    CreativeService.creative.id = creative.id;
    CreativeService.creative.privateKey = creative.privateKey;
    FlashService.push('success', 'Your ad has been saved.');

    return $q.resolve(response);
  }

  function failure(response) {
    let status = response.status;

    if (status === 400 && response.data.errorMessage) {
      FlashService.push('error', response.data.errorMessage);
    } else if (status === 401) {
      FlashService.push('error', 'Please sign in to manage your ads.');
    } else if (status === 404) {
      FlashService.push(
        'error',
        'This creative has been archived and is no longer editable.'
      );
    } else if (status === 422) {
      if (response.data && response.data.errors) {
        FlashService.push('error', response.data.errors);
      } else {
        FlashService.push('error', 'Please make sure your fields are valid.');
      }
    } else {
      FlashService.push('error', `Something went wrong. Server returned code ${response.status}.`);
    }

    return $q.reject(`Error: server returned ${response.status}`);
  }

  return vm;
}

SaveCreativeService.$inject = [
  '$http',
  '$q',
  'CreativeService',
  'DataService',
  'FlashService',
  'MixpanelService',
  'RenderService'
];
